module.exports = __webpack_public_path__ + "img/upload-gallery-image.a0f47710.svg";